export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<g clip-path="url(#clip0_134_5511)">
			<path
				d="M4.125 4.25C3.38672 4.25 2.8125 4.86523 2.8125 5.5625V8.1875H21.1875V5.5625C21.1875 4.86523 20.5723 4.25 19.875 4.25H4.125ZM2.8125 9.5V18.6875C2.8125 19.4258 3.38672 20 4.125 20H19.875C20.5723 20 21.1875 19.4258 21.1875 18.6875V9.5H2.8125ZM1.5 5.5625C1.5 4.12695 2.64844 2.9375 4.125 2.9375H19.875C21.3105 2.9375 22.5 4.12695 22.5 5.5625V18.6875C22.5 20.1641 21.3105 21.3125 19.875 21.3125H4.125C2.64844 21.3125 1.5 20.1641 1.5 18.6875V5.5625ZM6.75 12.125H17.25C17.5781 12.125 17.9062 12.4531 17.9062 12.7812C17.9062 13.1504 17.5781 13.4375 17.25 13.4375H6.75C6.38086 13.4375 6.09375 13.1504 6.09375 12.7812C6.09375 12.4531 6.38086 12.125 6.75 12.125ZM6.75 16.0625H17.25C17.5781 16.0625 17.9062 16.3906 17.9062 16.7188C17.9062 17.0879 17.5781 17.375 17.25 17.375H6.75C6.38086 17.375 6.09375 17.0879 6.09375 16.7188C6.09375 16.3906 6.38086 16.0625 6.75 16.0625ZM15.9375 5.35742L17.25 6.13672L18.5215 5.35742C18.8496 5.15234 19.2598 5.27539 19.4238 5.5625C19.6289 5.89062 19.5059 6.30078 19.2188 6.46484L17.5781 7.44922C17.373 7.57227 17.0859 7.57227 16.8809 7.44922L15.2402 6.46484C14.9531 6.30078 14.8301 5.89062 15.0352 5.5625C15.1992 5.27539 15.6094 5.15234 15.9375 5.35742Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_134_5511">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
